import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useServicesList(){

    const toast = useToast()

    const refServiceListTable = ref(null)

    const tableColumns = [
        {key:'image', label:'Image'},
        {key:'has_information', label:'Has Information' , sortable:true},
        {key:'title', label:'Title' , sortable:true},
        {key:'description', label:'Description' , sortable:true},
        {key:'content', label:'Content',sortable:true},
        {key:'sort_order', label:'Sort Order',sortable:true},
        {key:'is_active', label:'Is Active',sortable:true},
        {key:'actions'}
    ]

    const perPage = ref(10)
    const totalServices = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    

    const dataMeta = computed(() => {
        const localItemsCount = refServiceListTable.value ? refServiceListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1: 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalServices.value,
        }
    })

    const showMessage = (title,text,icon, variant) =>{
        toast({
            component: ToastificationContent,
            props: {
              title,
              text,
              icon,
              variant
            },
        })
    }

    const refetchData = () =>{
        refServiceListTable.value.refresh()
    }

    const getServiceImage = (image) =>  process.env.VUE_APP_IMAGE_URL+image

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })


    const service_title = ref(null)
    const service_slug = ref(null)
    const store_name = ref(null)
    const getHasInformation = ref(0)

    const fetchServices = (ctx, callback) => {

        store.dispatch('bar-service/fetchServices', {
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
        .then(response => {
            //console.log(response.data)
            const { services, total} = response.data
            getHasInformation.value = response.data.has_information
            // var arr = []
            // services.forEach(service => {
            //     arr.push({
            //         content: JSON.parse(service.content)
            //     })
            // })
            // console.log('arr', arr)
            callback(services)
            totalServices.value = total
            service_slug.value = response.data.service_slug
            service_title.value = response.data.service_title
            store_name.value = response.data.name
            // console.log('services.content', services[0].content)
            
        })
        .catch(() => {
            toast({
                component: ToastificationContent,
                props: {
                  title: 'Error fetching services list',
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
            })
        })
    }

    return {
        fetchServices,
        tableColumns,
        perPage,
        currentPage,
        totalServices,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refetchData,
        refServiceListTable,
        getServiceImage,
        showMessage,
        service_slug,
        service_title,
        store_name,
        getHasInformation
        
        //Extra Filters
    }

}